import request from '@/utils/request';


/**
 * 获取网站导航数据
 * @returns {Promise} 返回轮播图列表
 */
export const getNavList = () => {
  return request({
    url: '/web/site/navigation/tree',
    method: 'get'
  });
};

/**
 * 获取首页轮播图数据
 * @param {Object} params - 请求参数
 * @param {number} params.isTop - 是否顶部banner（1:是, 0:否）
 * @returns {Promise} 返回轮播图列表
 */
export const getBannerList = (params = {}) => {
  return request({
    url: '/web/site/banner/list',
    method: 'get',
    params
  });
};

/**
 * 获取首页医院动态列表
 * @param {Object} params - 请求参数
 * @param {number} params.page - 页码，默认1
 * @param {number} params.pageSize - 每页条数，默认10
 * @returns {Promise} 返回医院动态列表和分页信息
 */
export const getNewsList = (params = { page: 1, pageSize: 10 }) => {
  return request({
    url: '/home/news',
    method: 'get',
    params
  });
};

/**
 * 获取通知公告列表
 * @param {Object} params - 请求参数
 * @param {number} params.page - 页码，默认1
 * @param {number} params.pageSize - 每页条数，默认10
 * @returns {Promise} 返回通知公告列表和分页信息
 */
export const getNoticesList = (params = { page: 1, pageSize: 10 }) => {
  return request({
    url: '/home/notices',
    method: 'get',
    params
  });
};

/**
 * 获取首页医院介绍概览
 * @returns {Promise} 返回医院介绍概览信息
 */
export const getHospitalOverview = () => {
  return request({
    url: '/home/hospital/overview',
    method: 'get'
  });
};

/**
 * 获取首页科室列表
 * @returns {Promise} 返回科室列表
 */
export const getDepartmentList = () => {
  return request({
    url: '/home/departments',
    method: 'get'
  });
};

/**
 * 获取医生风采列表（支持分页）
 * @param {Object} params - 请求参数
 * @param {number} params.pageNum - 页码，默认1
 * @param {number} params.pageSize - 每页条数，默认12
 * @returns {Promise} 返回医生列表和分页信息
 */
export const getDoctorList = (params = { pageNum: 1, pageSize: 12 }) => {
  return request({
    url: '/web/site/doctor/list',
    method: 'get',
    params
  });
};

/**
 * 获取所有医生列表（不分页）
 * @returns {Promise} 返回所有医生列表
 */
export const getAllDoctorList = (params) => {
  return request({
    url: '/web/site/doctor/list',
    method: 'get',
    params
  });
};

/**
 * 获取医生详情
 * @param {number} id - 医生ID
 * @returns {Promise} 返回医生详情
 */
export const getDoctorDetail = (id) => {
  return request({
    url: `/web/site/doctor/${id}`,
    method: 'get',
  });
};


/**
 * 信息搜索列表
 * @param {string} params.keyword - 关键词
 * @param {number} params.pageNum - 页码，默认1
 * @param {number} params.pageSize - 每页条数，默认12
 * @returns {Promise} 返回医生列表和分页信息
 */
export const getSearchList = (params = { keyword: '' }) => {
  return request({
    url: '/web/site/global/search',
    method: 'get',
    params
  });
};



/**
 * 获取友情链接地址
 * @returns {Promise} 返回友情链接地址
 */
export const getFriendshipLinks = () => {
  return request({
    url: '/web/site/link/list',
    method: 'get'
  });
};
